import axios from 'axios';
import qs from 'qs';
import urls from '@/settings/urls';

export const GetCustomerFwAddresses = (id) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${id}/forward_addresses`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateCustomerFwAddress = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/forward_addresses`,
    params: {
      forward_address: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateCustomerFwAddress = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.admin.customers}/${data.customer_id}/forward_addresses/${data.addr_id}`,
    params: {
      forward_address: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const RemoveCustomerFwAddress = (data) => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${data.customer_id}/forward_addresses/${data.addr_id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerActivity = (id) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${id}/mail_items/stats`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerReceptionistList = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.receptionist
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const SubscribeCustomerToLiveReceptionist = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/live_receptionist_service`,
    params: {
      plan_id: data.plan_id
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UnsubscribeCustomerFromLiveReceptionist = (id) => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${id}/live_receptionist_service`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerPhoneList = (id) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${id}/phone_numbers`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerPhoneUsage = (id) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${id}/phone_numbers/usage_stats`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerCharges = (data) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${data.id}/charges`,
    params: data.params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const MakeCustomerCharge = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.admin.customers}/${data.id}/charges/${data.charge_id}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const CancelCustomerCharge = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/charges/${data.charge_id}/cancel`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const RefundCustomerCharge = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/charges/${data.charge_id}/refund`,
    params: {
      refund: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerOutgoing = (data) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${data.id}/phone_numbers/${data.phone_id}/outgoing_calls`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const AddCustomerOutgoing = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/phone_numbers/${data.phone_id}/outgoing_calls`,
    params: data.params
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateCustomerOutgoing = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.admin.customers}/${data.id}/phone_numbers/${data.phone_id}/outgoing_calls/${data.params.id}`,
    params: {
      caller_phone_number: data.params.caller_phone_number
    }
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const DeleteCustomerOutgoing = (data) => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${data.id}/phone_numbers/${data.phone_id}/outgoing_calls/${data.outgoing_id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerPhoneExtensions = (data) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${data.id}/phone_numbers/${data.phone_id}/phone_extensions`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateCustomerPhoneExtension = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/phone_numbers/${data.phone_id}/phone_extensions`,
    data: data.ext
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateCustomerPhoneExtension = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.admin.customers}/${data.id}/phone_numbers/${data.phone_id}/phone_extensions/${data.ext_id}`,
    params: data.ext,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const RemoveCustomerPhoneExtension = (data) => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${data.id}/phone_numbers/${data.phone_id}/phone_extensions/${data.ext_id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateCustomerPhoneNumber = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.admin.customers}/${data.id}/phone_numbers/${data.phone_id}`,
    params: {
      phone_number: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const DeleteCustomerPhoneNumber = (data) => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${data.id}/phone_numbers/${data.phone_id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const SearchCustomerPhoneNumbers = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/phone_numbers/search`,
    params: {
      search: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const BuyCustomerPhoneNumber = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/phone_numbers`,
    data: {
      phone_number: data.params
    },
    //paramsSerializer: data => qs.stringify(data, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerPhone = (data) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${data.id}/phone_numbers/${data.phone_id}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerPhonePorting = (id) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${id}/phone_porting`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const SendCustomerPhonePorting = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/phone_porting`,
    data: data.params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const PerformCustomCustomerAction = (data) => {

  const requestOptions = {
    method: data.method,
    url: `${urls.admin.customers}/${data.id}/${data.action}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const PerformCustomerSmsServiceAction = (data) => {
  /* Legend for methods:
    GET: get sms service params
    POST: activate sms service
    PUT: update sms service params
    DELETE: deactivate sms service
  */

  let requestOptions = {
    method: data.method,
    url: `${urls.admin.customers}/${data.id}/sms_service`
  };

  if (data.data)
    requestOptions.data = data.data;

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerJointAccounts = (id) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${id}/joint_accounts`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const AddCustomerJointAccount = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/joint_accounts`,
    params: {
      joint_account: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateCustomerJointAccount = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.admin.customers}/${data.id}/joint_accounts/${data.recipient_id}`,
    params: {
      joint_account: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const RemoveCustomerJointAccount = (data) => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${data.id}/joint_accounts/${data.account_id}`,
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetAllCustomerCardsInfo = (id) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${id}/credit_cards`,
  };

  return axios(requestOptions)
    .then(res => res.data);
};

export const CustomerAddCard = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/credit_cards`,
    data: data.params,
  };

  return axios(requestOptions)
    .then(res => res.data);
};

export const CustomerUpdateCard = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.customers}/${data.id}/credit_cards/${data.card_id}`,
    params: {
      source: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
};

export const CustomerDeleteCard = (data) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${data.id}/credit_cards/${data.card_id}`,
  };

  return axios(requestOptions)
    .then(res => res.data);
};

export const CustomerUpgradePlan = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/subscriptions/upgrade`,
    params: data.params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerNotarizePackages = (id) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${id}/notary_packages`
  };

  return axios(requestOptions)
    .then(res => res.data);
};

export const CreateCustomerNotarizePackage = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/notary_packages`,
    data: data.params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const ConfirmCustomerNotarizePackage = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/notary_packages/notarize_form1583`,
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const CancelCustomerNotarizePackage = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/notary_packages/${data.notary_package_id}/cancel`,
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerBankAccount = (id) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${id}/bank_account`,
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const AddCustomerBankAccount = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.customers}/${data.id}/bank_account`,
    data: {
      bank_account: data.params
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const SetCustomerBankDefault = (id) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.customers}/${id}/bank_account/set_default`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const DeleteCustomerBankAccount = (id) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${id}/bank_account`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerLinkToken = (id) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${id}/bank_account/link_token`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerLiveRecipients = (id) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${id}/additional_live_receptionist_accounts`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const AddCustomerLiveRecipient = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.customer_id}/additional_live_receptionist_accounts`,
    data: {
      additional_live_receptionist_account: data.params
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateCustomerLiveRecipient = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.customers}/${data.customer_id}/additional_live_receptionist_accounts/${data.user_id}`,
    data: {
      additional_live_receptionist_account: data.params
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const DeleteCustomerLiveRecipient = (data) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.customers}/${data.customer_id}/additional_live_receptionist_accounts/${data.user_id}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCustomerBalanceAdjustments = (data) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.customers}/${data.id}/account_balance_adjustments`,
    params: data.params || {}
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const AdjustCustomerBalance = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/account_balance_adjustments`,
    data: {
      adjustment: data.params
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}